import { getBaseRole } from '@/helpers/customRoles';
import { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'
import { Modal } from 'antd'
import { IcoRemove } from '@/utils/icons'
import amclasses from '@pages/Admin/CRM/styles/ammodal.module.css'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import classes from './index.module.css'
import cn from 'classnames'
import { useAddAlert } from '@/hooks/useAddAlert'
import Input from '@pages/Admin/CRM/components/base/Input/Input'
import Button from '@UI/New/Button'
import { telegramBotIntegrationApi } from '@/api'
import { isError } from '@/helpers/checkQuery'

interface ActivateTelegramBotProps {
  open?: boolean
  setOpen?: (open: boolean) => void
  necessarily?: boolean
}

const BOT_NAME = window?.location?.origin?.includes('lk.pifshtany.ru') ? 'lk_pifshtany_bot' : 'ImpTestDevBot'

const ActivateTelegramBot: FC<ActivateTelegramBotProps> = ({
                                                             open = true,
                                                             setOpen = () => {},
                                                             necessarily = false,
                                                           }) => {
  const addAlert = useAddAlert()

  const profile = useSelector(selectProfile)
  const userid = profile?.id

  const [code, setCode] = useState('')
  const [isActive, setIsActive] = useState(open)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    setIsActive(open)
  }, [open])

  useEffect(() => {
    if (setOpen) {
      setOpen(isActive)
    }
  }, [isActive, setOpen])

  const handlerSubmit = async () => {
    if (!userid || !code) return

    setSubmitting(true)
    telegramBotIntegrationApi
        .activate({ user_id: userid, code })
        .then((res) => {
          if (isError(res)) throw new Error()
          addAlert({
            title: 'Успешно',
            text: 'ТГ-Бот успешно активирован. Страница обновится через 2 секунды',
            type: 'success',
          })
          setIsActive(false)
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch(() => {
          addAlert({
            title: 'Ошибка',
            text: 'Некорректный код активации или ошибка сервера',
            type: 'error',
          })
        })
        .finally(() => {
          setSubmitting(false)
        })
  }

  return (
      <Modal
          open={isActive}
          closable={!necessarily}
          footer={null}
          title={
            <div className={mclasses.modalHeader}>
              <p className={mclasses.modalHeaderTitle}>
                {necessarily
                    ? 'Необходимо активировать ТГ-Бота'
                    : 'Активировать ТГ-Бота'}
              </p>
              {!necessarily && (
                  <div
                      className={mclasses.closeIcon}
                      onClick={() => setIsActive(false)}
                  >
                    <IcoRemove />
                  </div>
              )}
            </div>
          }
          centered
          maskClosable
          className={cn(amclasses.modal)}
      >
        <div className={classes.description}>
          <p>
            Активируйте ТГ-бота, который будет уведомлять вас об изменениях на
            платформе.
          </p>
          <p>
            Перейдите по ссылке:{' '}
            <a
                href={`https://t.me/${BOT_NAME}?start=${buildTelegramStartPayload({
                  origin: window.location.origin,
                  user_id: userid,
                })}`}
                className={classes.link}
                target="_blank"
                rel="noopener noreferrer"
            >
              ссылке
            </a>{' '}
            и нажмите «Начать». После этого введите код подтверждения ниже.
          </p>
        </div>

        <Input
            type="number"
            placeholder="Код подтверждения"
            value={code}
            onChange={(e) => setCode(e.target.value)}
        />

        <Button
            isLoading={submitting}
            onClick={handlerSubmit}
            className={classes.submitButton}
            disabled={!code || submitting}
        >
          Активировать
        </Button>
      </Modal>
  )
}

const RequiredActivateTelegramBot = () => {
  const profile = useSelector(selectProfile)
  const userRole = profile.role

  const settings = useSelector((store: any) => store.settings)
  const status = useSelector((store: any) => store.settings?.status)
  const loadingSettings = status < 2
  const [needActivateTelegramBot, setNeedActivateTelegramBot] = useState(false)

  useEffect(() => {
    console.log('userRole', userRole)

    if (
        loadingSettings ||
        !profile?.id ||
        settings?.telegramBotIntegrationEnabled !== '1' ||
        !userRole
    ) {
      setNeedActivateTelegramBot(false)
      return
    }

    switch (getBaseRole(userRole)) {
      case 'children':
        if (settings?.mandatoryTelegramBotIntegrationChildren !== '1') {
          setNeedActivateTelegramBot(false)
          return
        }
        break

      case 'parent':
        if (settings?.mandatoryTelegramBotIntegrationParent !== '1') {
          setNeedActivateTelegramBot(false)
          return
        }
        break

      default:
        if (settings?.mandatoryTelegramBotIntegrationStaff !== '1') {
          setNeedActivateTelegramBot(false)
          return
        }
        break
    }

    telegramBotIntegrationApi
        .checkIsActive({ user_id: profile?.id })
        .then((res) =>
            setNeedActivateTelegramBot(res?.data?.data?.is_active === false),
        )
        .catch(() => setNeedActivateTelegramBot(false))
  }, [
    settings,
    profile,
    loadingSettings,
  ])

  return needActivateTelegramBot && <ActivateTelegramBot necessarily={true} />
}
const buildTelegramStartPayload = (data: { origin: string; user_id: number }) => {
  const { origin, user_id } = data

  // base64url encode origin
  const originEncoded = btoa(origin)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '')

  return `${user_id}_${originEncoded}`
}

export default ActivateTelegramBot
export { RequiredActivateTelegramBot }
